var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeStorage = function SvgHomeStorage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentcolor"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "home_storage_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#home_storage_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.583 17.5q-.603 0-1.073-.396a1.63 1.63 0 0 1-.572-1L2.667 8.48a.83.83 0 0 1 .177-.677.77.77 0 0 1 .635-.302h13.042q.396 0 .635.302.24.302.177.677l-1.27 7.625q-.104.604-.573 1t-1.073.396zM4.5 9.167l1.063 6.666h8.875L15.5 9.167zM8.333 12.5h3.334q.354 0 .593-.24.24-.24.24-.593a.8.8 0 0 0-.24-.594.8.8 0 0 0-.593-.24H8.333a.8.8 0 0 0-.593.24.8.8 0 0 0-.24.594q0 .354.24.593.24.24.593.24M5 6.667a.8.8 0 0 1-.594-.24.8.8 0 0 1-.24-.594q0-.354.24-.593Q4.646 5 5 5h10q.354 0 .594.24t.24.593-.24.594a.8.8 0 0 1-.594.24zm1.667-2.5a.8.8 0 0 1-.594-.24.8.8 0 0 1-.24-.594q0-.354.24-.593.24-.24.594-.24h6.666q.354 0 .594.24t.24.593-.24.594a.8.8 0 0 1-.594.24z"
  }))));
};
export default SvgHomeStorage;